import { SearchParams } from '@/types'
import { FlowRuleType, UpdateFlowRule } from '@/types/hydraulic'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const flowRuleApi = {
  getAll(searchParams: SearchParams) {
    const url = '/api/flowrule'
    return axiosClient.get(url + queryStringify(searchParams))
  },
  getById(interfaceId: number, id: number): Promise<{ data: FlowRuleType }> {
    const url = `api/flowrule/${interfaceId}/${id}`
    return axiosClient.get(url)
  },

  getSrcId(interfaceId: number) {
    const url = `api/flowrule/get-src-id?interfaceId=${interfaceId}`
    return axiosClient.get(url)
  },
  create(payload: UpdateFlowRule) {
    const url = 'api/flowrule'
    return axiosClient.post(url, payload)
  },

  update(payload: UpdateFlowRule) {
    const url = 'api/flowrule'
    return axiosClient.put(url, payload)
  },

  delete(interfaceId: string, id: string) {
    const url = `api/flowrule/?interfaceId=${interfaceId}&id=${id}`
    return axiosClient.delete(url)
  },
}

export default flowRuleApi
